import React from "react"
import { Switch, Route } from "react-router-dom"

// routes
import Auth from "./Auth"
import Main from "./Main"

function Routes() {
  return (
    <Switch>
      <Route path="/auth" component={Auth} />
      <Route component={Main} />
    </Switch>
  )
}

export default Routes
